package com.klantenstop.web.data.models.domain

import com.klantenstop.web.data.models.dto.responses.UserDto
import kotlinx.datetime.Instant
import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toInstant

data class User(
    val id: String,
    val firstName: String,
    val lastName: String,
    val email: String,
    val avatar: MediaFile?,
    val createdAt: Instant,
    val updatedAt: Instant,
    val isVerified: Boolean,
    val verificationSentAt: Instant?
)

fun UserDto.toUser() = User(
    id = this.id,
    firstName = firstName,
    lastName = lastName,
    email = email,
    avatar = avatar?.toMediaFile(),
    createdAt = LocalDateTime.parse(createdAt).toInstant(TimeZone.UTC),
    updatedAt = LocalDateTime.parse(updatedAt).toInstant(TimeZone.UTC),
    isVerified = isVerified,
    verificationSentAt = verificationSentAt?.let { LocalDateTime.parse(it).toInstant(TimeZone.UTC) }
)
